<template>
  <ZtLink
    :to="url"
    class="group grid grid-cols-[auto_1fr] gap-3 border-b border-b-border py-3 hover:bg-scheme-main-bis focus:bg-scheme-main-bis"
    @click.prevent="$emit('click')"
  >
    <div class="aspect-4/3 w-28 bg-scheme-main">
      <MediaImage v-if="image" v-bind="image" responsive-style="column_fifth" />
    </div>
    <div>
      <h3
        class="text-size-5 text-scheme-invert group-hover:text-primary"
        v-html="highlight || title"
      />
      <div
        class="flex items-center gap-[0.3em] text-size-6 font-bold text-muted group-hover:text-primary"
      >
        <SpriteSymbol :name="icon" class="size-[0.7em]" />
        <span>{{ bundleLabel }}</span>
      </div>
    </div>
  </ZtLink>
</template>

<script lang="ts" setup>
import type { NuxtSvgSpriteSymbol } from '#nuxt-svg-sprite/runtime'
import type { SearchHitContent } from '~/layers/search/server/api/search/fulltext'

const props = defineProps<SearchHitContent>()

defineEmits(['click'])

const { $texts } = useEasyTexts()

const BUNDLE_ICON: Record<string, NuxtSvgSpriteSymbol> = {
  place: 'map',
  accomodation: 'accomodation',
  tour: 'tour',
}

const icon = computed<NuxtSvgSpriteSymbol>(() => {
  if (props.bundle) {
    return BUNDLE_ICON[props.bundle] || 'info'
  }

  return 'info'
})

const bundleLabel = computed(() => {
  if (props.bundle === 'place') {
    return $texts('bundle.place', 'Place')
  } else if (props.bundle === 'accomodation') {
    return $texts('bundle.accomodation', 'Accommodation')
  } else if (props.bundle === 'tour') {
    return $texts('bundle.tour', 'Tour')
  }

  return $texts('bundle.fallback', 'Information')
})
</script>
